const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

/**
 * Get the country name from the country code.
 *
 * @param code - The country code (e.g., 'US', 'FR', 'DE').
 * @returns The country name corresponding to the code, or null if the code is invalid or not found.
 *
 * @example
 * getCountryName('US'); // "United States"
 */
export function getCountryName(code: string): string | null {
    if (!code) return null;
    try {
        return regionNames.of(code) ?? null;
    } catch {
        return null;
    }
}
